// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__149n6","productName":"Table_productName__1MFGQ"};